/**
 * Smart Lexicon - Main Application
 *
 * React Router setup with root routes.
 * AuthProvider wraps the app for authentication state.
 * RequireAuth guards protected routes with login redirect.
 */

import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { RequireAuth } from './components/auth/RequireAuth'
import { LoginPage } from './components/auth/LoginPage'
import { AuthCallback } from './components/auth/AuthCallback'
import { AppShell } from './components/AppShell'
import { GenerateView } from './components/views/GenerateView'
import { ReviewView } from './components/views/ReviewView'
import { LibraryView } from './components/views/LibraryView'
import { SettingsView } from './components/views/SettingsView'
import { StatsView } from './components/views/StatsView'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes (no AppShell, no auth required) */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Protected routes (AppShell + auth required) */}
        <Route path="/*" element={
          <RequireAuth>
            <AppShell>
              <Routes>
                <Route path="/" element={<GenerateView />} />
                <Route path="/review" element={<ReviewView />} />
                <Route path="/library" element={<LibraryView />} />
                <Route path="/stats" element={<StatsView />} />
                <Route path="/settings" element={<SettingsView />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppShell>
          </RequireAuth>
        } />
      </Routes>
    </AuthProvider>
  )
}

export default App
